import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";
import MediaPicker from "@/components/MediaPicker";

export default function Media() {
  const { t } = useLang();
  const nav = useNavigate();
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <div>
          <h1 className="font-head font-black text-3xl sm:text-4xl">{t("nav_media")}</h1>
          <p className="text-stone-500 mt-1">{t("media_step_sub")}</p>
        </div>
        <Button onClick={() => nav("/create")} data-testid="media-create-btn" className="rounded-full bg-primary hover:bg-[#6D28D9] font-bold">
          <Sparkles size={18} className="mr-2" /> {t("nav_create")}
        </Button>
      </div>
      <div className="bg-white rounded-3xl border-2 border-stone-200 p-6">
        <MediaPicker />
      </div>
    </div>
  );
}
